<!-- pc端页头 -->
<template viewport>
    <div class="header">
        <div class="header-inner">
            <img src="../../assets/images/txbc.png" alt="" class="logo">

            <ul class="nav">
                <div v-for="(item, index) in list" :key="index">
                    <li class="router-link-exact-active" style="min-width:45px;" @click="refresh">
                        <router-link v-show="datalang == 'zh'" :to=item.path>{{ item.name }}</router-link>
                        <router-link v-show="datalang != 'zh'" :to=item.path class="link_en">{{ item.nameEn }}</router-link>
                    </li>
                </div>
            </ul>

            <!-- 论坛按钮 -->
            <button v-if="datalang == 'zh'" @click="goForum" class="forum">时尚论坛</button>
            <button v-else @click="goForum" class="forum2">FORUM</button>

            <div class="inp">
                <!-- <i class="el-icon-search inp-search"></i> clearable -->
                <el-input :placeholder="$t('navbar.EnterSearch')" v-model.trim="searchObj.keyWord" @keyup.enter.native="getInputValue"
                    ref="ref" @focus="gofabric"></el-input>
                <el-button class="inp-btn" @click="getInputValue"><i class="el-icon-search inp-search-btn"></i></el-button>
            </div>

            <!-- <img src="../../assets/images/avatar.png" alt="" class="avatar-img"> -->

            <!-- 国籍及语言弹框 -->
            <div class="nationality_language" @click="openLanguage">
                {{ this.nationality }} | {{ this.languages }}
            </div>

            <div style="display: none;">
                <!-- 这里是为了不通过弹框也能获取 this.nationality和this.languages的值-->
                <!-- 国家按钮 -->
                <Nation class="right-menu-item"></Nation>
                <!-- 国际化按钮 -->
                <Lang class="right-menu-item"></Lang>
            </div>

            <!-- 时区选择 -->
            <div class="form_group">
                <el-select v-model="currentTimezone" :placeholder="$t('navbar.SelectTimezone')">
                    <el-option v-for="zone in timezones" :key="zone.value" :value="zone.value" :label="datalang == 'zh' ? zone.label : zone.labelEn">
                        {{ datalang == 'zh' ? zone.label : zone.labelEn }}
                    </el-option>
                </el-select>
            </div>

            <div class="but">
                <!-- 俱乐部 -->
                <button class="button-club" @click="joinClub">{{ $t('navbar.Club') }}</button>
                <!-- svip -->
                <!-- <button class="button-svip" @click="getSvip">Svip</button> -->
                <!-- 登录 -->
                <button class="button-login" v-if="!token" @click="dakai">{{ token ? user : $t('navbar.Login')}}</button>
                <button class="button-login2" v-else @click="dialogFormVisible3 = true">{{ token ? user : $t('navbar.Login') }}</button>

                <!-- 商家入驻 -->
                <!-- <button v-show="token" @click="goShopEntry" class="enter">店铺入驻</button> -->

                <!-- 测试版 -->
                <el-dialog title="" :visible.sync="dialogFormVisible" fullscreen class="dialog">
                    <div class="dialog-inner">
                        <el-form ref="loginForm" :model="loginForm" @submit.native.prevent>
                            <div class="dialog-inner-top">
                                <button class="login-btn" style="margin-bottom: 20px;">{{$t('navbar.Login')}}</button>
                            </div>
                            <div class="login">
                                <div class="dialog-inner-footer">
                                    <el-form-item label="" prop="username" :rules="{ required: true, message: $t('navbar.UserNameCannotEmpty') }">
                                        <el-input :placeholder="$t('navbar.AccountNumber')" v-model.trim="loginForm.username" clearable
                                            class="dialog-inner-footer-input"></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="password" :rules="{ required: true, message: $t('navbar.PasswordCannotEmpty') }"
                                        style="margin-bottom: -15px;">
                                        <el-input :placeholder="$t('navbar.Password')" v-model.trim="loginForm.password" show-password
                                            @keyup.enter.native.once="gologin(loginForm)" class="dialog-inner-footer-input"
                                            style="margin: 20px 0;"></el-input>
                                    </el-form-item>

                                    <span class="dialog-inner-footer-span" style="cursor: pointer;"
                                        @click="dialogFormVisible2 = true, dialogFormVisible = false">{{$t('navbar.ForgetThePassword')}}?</span>
                                    <el-form-item>
                                        <el-button class="dialog-inner-footer-btn" @click.prevent="gologin(loginForm)"
                                            v-throttle="2000">{{$t('navbar.Login')}}</el-button>
                                    </el-form-item>

                                    <!-- <el-form-item>
                                        <el-button class="dialog-inner-footer-btn btn-join-club" @click.prevent="joinClub"
                                            v-throttle="2000">{{$t('navbar.joinClub')}}</el-button>
                                    </el-form-item> -->

                                    <!-- <el-form-item>
                                        <el-button class="dialog-inner-footer-btn btn-expert-recruitment" @click.prevent="expertRecruitment"
                                            v-throttle="2000">{{$t('navbar.ExpertRecruitment')}}</el-button>
                                    </el-form-item> -->
                                </div>
                                <div class="line"></div>
                                <div class="dialog-img-box">
                                    <div class="policy" style="width: 100%;text-align: center;">
                                        <a href="#">《{{$t('navbar.PrivacyPolicy')}}》</a>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-dialog>
                <el-dialog title="" :visible.sync="dialogFormVisible2" class="dialog2" fullscreen>
                    <p class="pp1">{{$t('navbar.RetrievePassword')}}</p>
                    <p class="pp2">{{$t('navbar.Service')}}<span style="color: #576B95;margin-left: 5px;">0510-86562540</span></p>
                </el-dialog>

                <el-dialog title="" :visible.sync="dialogFormVisible3" class="dialog3" fullscreen>
                    <p class="pp3">{{$t('navbar.Logout')}}?</p>
                    <span class="dialog-footer">
                        <el-button @click="dialogFormVisible3 = false" class="dialog-footer-btn-one">{{$t('navbar.Cancel')}}</el-button>
                        <el-button @click="uplogin" class="dialog-footer-btn-two">{{$t('navbar.Confirm')}}</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="" :visible.sync="visibleLanguage" class="dialog_lang" fullscreen>
                    <div class="header">
                        <div class="header_inner">
                            {{$t('navbar.choosePreferences')}}
                        </div>
                        
                    </div>
                    <div class="body">
                        <div class="nationality">
                            <span>{{$t('navbar.regions')}}</span>
                            <Nation class="right-menu-item"></Nation>
                        </div>
                        <div class="language">
                            <span>{{$t('navbar.language')}}</span>
                            <Lang class="right-menu-item"></Lang>
                        </div>
                    </div>

                    <!-- <span class="dialog-footer">
                        <el-button @click="" class="dialog-footer-btn-two">{{$t('navbar.Confirm')}}</el-button>
                    </span> -->
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import { LoginApi, commodityList } from '../../api/index'
import { mapState, mapMutations } from 'vuex'
import timezones from "../../utils/timeZone.json"
// import { setToken, setUser, removeToken } from "@/utils/cookie.js"
import Lang from '../pc/Lang/index.vue'
import Nation from '../pc/Nation/index.vue'
export default {
    data() {
        return {
            list: [
                {
                    path: '/home',
                    name: '首页',
                    nameEn: 'HOME',
                },
                {
                    path: '/selection',
                    name: '所有选品',
                    nameEn: 'ALL ITEMS',
                },
                // {
                //     path:'/selection',
                //     name: '选品中心',
                //     nameEn:'Selection',
                // },
                // {
                //     // id: 3,
                //     path: '/marketplace',
                //     name: '应用市场',
                //     nameEn:'MARKETPLACE',
                // },
                // {
                //     path: '/forum', //http://172.16.2.234:8088/
                //     name: '论坛',
                //     nameEn:'FORUM'
                // },
            ],
            index: 0,
            loginForm: {
                username: '',
                password: ''
            },
            currentUser: '',

            active: 0,
            tabIndex: 0,
            input: '',
            
            dialogFormVisible: false,
            dialogFormVisible2: false,
            dialogFormVisible3: false,
            visibleLanguage: false,
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            activeIndex: '1',
            isShowFooter: true,
            // activeName: 'first',
            formLabelWidth: '100px',
            value: '',
            value2: '',

            language: 'zh', // 选中的语言
            languagelist: ['english', 'zh'],

            searchObj: {
                keyWord: '',
                page: 1,
                pageSize: 18
            },
            idsObj: {
                current: 1,     //当前第几页
                ids: null,          //列表选择商品 传入的商品ID  默认进入页面展示的数据
                pageSize: 18
            },
            isRefresh:false,
            datalang: '',   //路由语言判断
            nationality:'', //国籍文字
            languages:'',   //语言文字

            timezones: [],
        }
    },
    components: {
        Lang,
        Nation
    },
    watch: {
        // $route(to, from) {
        //     if (to.path == '/forum') {
        //         window.open('http://172.16.2.225:8088/')
        //     }
        // },
    },
    methods: {
        goForum() {
            window.open('http://172.16.2.225:8088/')
            // window.open('http://form.fabtank.cn:18088/')
        },
        goShopEntry() {
            this.$router.push('/shopEntry')
            console.log('去往商家入驻页面')
        },
        refresh() {
            // console.log('刷新页面1！')
            if (this.$route.path == '/fabric' || this.$route.path == '/selection') {
                // console.log('刷新页面2！')
                this.isRefresh = true
                //让点击事件在在面料库页面触发，在面料库刷新，不在这里使用this.$router.go(0)，优化体验
                this.$EventBus.$emit("isRefresh", this.isRefresh);

                // this.$router.go(0)
                // if (this.idsObj.current != 1) {
                //     // console.log('刷新页面3！')
                //     this.$router.go(0)
                // }
            }
        },
        gofabric() {
            if (this.token) {
                if (this.$route.path != '/selection') {
                    this.$router.push('/selection')
                    // console.log('99999');
                }
            }
        },
        selectlang(e) {
            console.log(e.target.selectedIndex)
            // 根据监听改变获取到的值去数组里找到对应的值
            localStorage.setItem('lang', this.languagelist[e.target.selectedIndex])
            this.$i18n.locale = this.languagelist[e.target.selectedIndex] //切换字典文件
        },

        dakai() {
            // console.log("打开弹出层")
            this.dialogFormVisible = true
        },
        uplogin() {
            console.log('退出登录！')
            // window.Cookie.clear()
            this.dialogFormVisible3 = false

            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            if (keys) {
                for (var i = keys.length; i--;) {
                    document.cookie =
                        keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); //清除当前域名下
                    document.cookie =
                        keys[i] +
                        "=0;path=/;domain=" +
                        document.domain +
                        ";expires=" +
                        new Date(0).toUTCString();
                    document.cookie =
                        keys[i] +
                        "=0;path=示例：/index.vue（不同域的path,也就是你清除不了的cookie）;domain=示例：10.10.10.208（不同域的domain,也就是你清除不了的cookie）;expires=" +
                        new Date(0).toUTCString();
                }
            }

            sessionStorage.clear();
            this.$router.push('/home')
            //想清空vuex中的数据，让页面重新加载就行了
            window.location.reload()

        },
        changeActive(index) {
            this.active = index;
            // this.index = index
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        // handleClick(tab, event) {
        //     console.log(tab, event);
        // },

        //登录接口
        async goLoginApi() {
            let res = await LoginApi(this.loginForm)
            // console.log(res, "登录返回的数据！")
            // this.token = res.data.result
            // console.log(this.token)
            if (res.status === 200 && res.data.result) {
                // 登录成功,将token保存
                // window.localStorage.setItem("token", res.data.result)
                // this.$store.state.token = res.data.result
                // Cookies.set("token", res.data.result)
                // console.log(Cookies.get('token'))
                // 登录的时候手动设置 store 
                // setToken(res.data.result)
                this.setToken(res.data.result)
                // this.$store.state.token = res.data.result
                this.setUser(this.loginForm.username)
            }
            if (res.data.success) {
                this.$message({
                    message: '登录成功！',
                    type: 'success'
                });
                //上面定义了什么类型 这里清空时就要用什么类型 否则控制台会报错
                this.loginForm = {}
                this.dialogFormVisible = false
            } else {
                this.$message.error('用户名或密码不正确，请重新登录！');
            }
        },
        gologin(loginForm) {
            this.goLoginApi(loginForm)
            // console.log("登录")
        },
        goregister() {
            console.log("注册")
        },
        async getcommodityList(idsObj) {
            let { data: res } = await commodityList(idsObj);
            console.log(res)
        },
        getInputValue() {
            if (this.token) {
                // if (this.$route.path != '/fabric') {
                //     this.$router.push('/fabric')
                // }

                if (this.searchObj.keyWord !== '') {
                    // this.goSearchKeyWord()
                    // console.log(this.searchObj.keyWord)
                    //将关键字传入fabric页面 在那边请求接口
                    this.$EventBus.$emit("msg", this.searchObj.keyWord);
                    this.searchObj.keyWord = ''
                    // console.log('66666');
                } else {
                    // this.$message.error('请输入搜索词！');
                    this.getcommodityList(this.idsObj)
                    // window.location.reload()
                    this.$router.go(0)
                }
            } else {
                alert('请先登录！')
            }
        },
        joinClub() {
            this.$router.push('/joinClubSupplie');
            this.dialogFormVisible = false
        },
        openLanguage(){
            this.visibleLanguage = true
        },
        // expertRecruitment(){
        //     this.$router.push('/recruitment');
        //     this.dialogFormVisible = false
        // },
        ...mapMutations(['setToken']),
        ...mapMutations(['setUser']),
        ...mapMutations(['setSelectedTimezone']),

        getSvip(){
            if(this.$route.path == '/svip'){
                
            }else{
                this.$router.push('/svip');
            }
        },
    },
    //引入 getters
    computed: {
        token() {
            return this.$store.state.token
        },
        user() {
            return this.$store.state.user
        },
        // ...mapGetters(['getToken'])

        // 使用自定义计算属性，包含getter和setter
        currentTimezone: {
            get() {
                return this.selectedTimezone; // 从Vuex获取值
            },
            set(timezone) {
                this.setSelectedTimezone(timezone); // 调用mutation更新Vuex
            }
        },
        ...mapState(['selectedTimezone']),
    },
    created() {
        // 获取缓存的语种，如若没有（新用户），保存当前默认语言
        if (localStorage.getItem('lang')) {
            this.language = localStorage.getItem('lang')
        } else {
            localStorage.setItem('lang', this.language)
        }
        this.datalang = this.$i18n.locale

        this.$EventBus.$on('this.languageValue', (data) => {
            this.languages = data
            // console.log('这是语言',this.languages);
        })
        this.$EventBus.$on('this.languageValue_n', (data) => {
            this.nationality = data
            // console.log('这是国籍',this.nationality);
        })

        this.timezones = timezones
    },
    mounted() {
        this.$EventBus.$on("page", (page) => {
            this.idsObj.current = page;
        });
        this.$EventBus.$on("pages", (pages) => {
            this.idsObj.current = pages;
        });
    },
    beforeDestroy() {
        //移除监听事件"msg"
        this.$EventBus.$off("msg");
    },
}
</script>

<style lang="scss">
.router-link-active {

    &.router-link-exact-active {
        font-weight: 700;
        border-bottom: 8px;
        position: relative;
        padding-bottom: 34px;
        color: black;
    }
    &.router-link-exact-active::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 8px;
        background-color: #FF235A;
        border-radius: 10px 10px 0 0;
    }
}

* {
    margin: 0;
    padding: 0;
}

.header {
    width: 100%;
    border-bottom: 2px solid #D6DFE8;

    .el-dialog__wrapper {
        top: 200px;
    }

    .el-dialog__body {
        padding: 0;
    }

    .header-inner {
        max-width: 1920px;
        height: 88px;
        line-height: 88px;
        margin: auto;
        display: flex;
        align-items: center;
        position: relative;
        background-color: #F2F5F8;

        .logo {
            width: 170px;
            margin-left: 40px;
        }

        .nav {
            display: flex;
            list-style: none;
            // margin-top: -68px;
            margin-left: 5%;
            // width: 320px;
            width: 240px;
            // height: 27px;
            justify-content: space-evenly;

            li {
                min-width: 30px;
                height: 88px;
                overflow: hidden;
                font-family: MiSans;
                font-size: 20px;
                letter-spacing: 0em;
                color: #3D3D3D;
                text-align: center;

                .link_en{
                    font-size: 16px;
                }
            }
        }

        a {
            text-decoration: none;
            font-size: 20px;
            color: black;
        }

        .forum {
            // width: 120px;
            margin-top: -2px;
            height: 100%;
            vertical-align: middle;
            font-family: MiSans;
            border: none;
            font-size: 20px;
            background-color: #F2F5F8;
            // margin-left: 2%;
            cursor: pointer;
        }
        .forum2{
            // width: 120px;
            height: 100%;
            vertical-align: middle;
            font-family: MiSans;
            border: none;
            font-size: 16px;
            background-color: #F2F5F8;
            // margin-left: 2%;
            cursor: pointer;
        }

        // .right-menu-item {
        //     margin-left: 1%;
        // }

        .inp {
            // position: absolute;
            margin-left: 5%;
            width: 480px;
            line-height: 42px;
            border: 1px solid #FF235A;
            border-radius: 10px;
            display: flex;
            align-items: center;
            background-color: #ffffff;

            .inp-search {
                font-size: 26px;
                margin-left: 16px;
                margin-top: 2px;
            }

            input {
                font-size: 16px;
                height: 40px;
                line-height: 40px;
                // position: absolute;
                // width: 300px;
                width: 85%;
                // margin-left: 10px;
                margin-left: 2%;
                border: none;
                outline: none;
                background-color: #ffffff;
            }

            .inp-btn {
                width: 45px;
                height: 34px;
                background-color: #FF235A;
                border: none;
                border-radius: 10px;
                margin-right: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;

                .inp-search-btn {
                    font-size: 20px;
                }
            }
        }

        .nationality_language{
            height: 40px;
            line-height: 40px;
            margin-left: 3%;
            padding: 0 5px;
            font-size: 16px;
            cursor: pointer;
            &:hover{
                height: 39px;
                border-bottom: 1px solid #3D3D3D;
            }
        }

        .avatar-img {
            // position: absolute;
            // margin-left: 30px;
            margin-left: 2%;
            width: 35px;
            height: 35px;
            border: 1px solid black;
            border-radius: 50%;
            z-index: 999;
        }

        .but {
            position: absolute;
            right: 30px;
            width: 260px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            // margin-left: 1%;
            // margin-right: 1%;

            button {
                width: 90px;
                height: 40px;
                line-height: 40px;
                border-radius: 10px;
                font-size: 16px;
            }

            .button-club,.button-svip{
                opacity: 1;
                background: #FFFFFF;
                border: 1px solid #FF235A;
                color: #FF235A;
            }

            .button-login {
                background: #FF235A;
                color: #FFFFFF;
                border: none;
                // padding: 0 15px;
                // border: 1px solid #ABB8C2;
                // display: flex;
                // justify-content: center;
                // align-items: center;
            }

            .button-login2 {
                font-size: 20px;
                background: #FFFFFF;
                border: none;
            }

            .enter {
                width: 90px;
                margin-left: 10px;
                margin-right: 20px;
            }

            .dialog {
                // margin:0 !important;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -320%;
                margin-top: 65%;
                // margin: auto;
                // height: 540px;
                width: 475px;
                height: 580px; 
                // width: 475px;
                // height: 640px;
                min-width: 475px;
                // min-height: 640px;
                max-height: 580px;
                // height: 30%;
                background-color: #FF235A;
                border-radius: 40px;
                box-sizing: border-box;

                .dialog-inner {
                    margin-top: 40px;
                    padding: 0 40px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    // align-content: space-evenly;

                    button {
                        border: none;
                        font-size: 20px;
                        width: 50px;
                        line-height: 27px;
                        background-color: white;
                    }

                    .scan-box {
                        display: flex;
                        justify-content: center;
                        margin: 50px 0 30px -38px;

                        img {
                            width: 154px;
                            height: 156px;
                            padding: 29px 35px 40px 36px;
                            border-radius: 15px;
                            box-shadow: 2px 2px 4px 4px #F2F2F2;
                        }
                    }

                    .line {
                        width: 450px;
                        height: 1px;
                        border-top: 1px solid #D8D8D8;
                        margin: 12px 0 10px 0;
                    }

                    .account-box {
                        width: 260px;
                        height: 44px;
                        margin: 248px 0 25px 0;
                        display: flex;
                        align-items: center;

                        span {
                            display: block;
                            padding: 6px 11px 7px 34px;
                            border: 1px solid #787476;
                            border-radius: 20px;
                            font-size: 16px;

                            .img-hsj {
                                width: 16px;
                                height: 16px;
                                margin: 4px 0 10px -25px;
                            }
                        }

                        img {
                            width: 35px;
                            height: 35px;
                        }

                        .img-qq {
                            margin-left: 160px;
                        }

                        .img-wb {
                            margin-left: 220px;
                        }
                    }

                    .dialog-inner-top {
                        display: flex;
                        justify-content: center;
                        // .login-btn:focus{
                        //     border-bottom: 1px solid #FF235A;
                        // }
                    }

                    .dialog-inner-footer {
                        // height: 350px;
                        height: 50%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-evenly;

                        .dialog-inner-footer-input,
                        .el-input__inner {
                            font-size: 16px;
                            width: 326px;
                            height: 44px;
                            border-radius: 10px;
                            // background-color: aqua;
                        }

                        .dialog-inner-footer-span {
                            font-size: 20px;
                            margin-left: 200px;
                        }

                        .dialog-inner-footer-btn {
                            font-size: 20px;
                            width: 326px;
                            height: 44px;
                            border-radius: 20px;
                            background-color: #FF235A;
                            color: white;
                        }

                        .btn-join-club{
                            background-color: rgb(235, 235, 235);
                            color: rgba($color: #000000, $alpha: 0.9);
                            border: 1px solid #EEEFF2;
                        }

                        .btn-expert-recruitment{
                            background-color: rgb(158, 223, 248);
                            color: rgba($color: #414141, $alpha: 0.9);
                            border: 1px solid #EEEFF2;
                        }
                    }

                    .dialog-img-box {
                        width: 100%;
                        height: 30px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                    } 
                }
            }

            .dialog2 {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -320%;
                margin-top: 85%;
                // margin-left: -238px;
                // margin-top: -170px;
                // margin: auto;
                width: 500px;
                height: 340px;
                border-radius: 40px;

                .pp1 {
                    font-size: 30px;
                    width: 100%;
                    text-align: center;
                    margin-top: 20px;
                }

                .pp2 {
                    width: 100%;
                    font-size: 24px;
                    text-align: center;
                    margin-top: 30px;
                }
            }

            .dialog3 {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -320%;
                margin-top: 85%;
                // margin-left: -238px;
                // margin-top: -180px;
                // margin: auto;
                width: 475px;
                height: 360px;
                border-radius: 40px;

                .pp3 {
                    width: 100%;
                    text-align: center;
                    font-size: 24px;
                    font-weight: 700;
                    margin-top: 40px;
                }

                .dialog-footer {
                    margin: 55px;

                    button {
                        border: none;
                        font-size: 20px;
                        width: 50px;
                        // height: 40px;
                        line-height: 20px;
                        // background-color: white;
                    }

                    .dialog-footer-btn-one {
                        width: 100px;
                        background-color: #F4F4F5;
                        margin: 60px 50px;
                        color: black;
                    }

                    .dialog-footer-btn-two {
                        width: 100px;
                        background-color: #409EFF;
                        color: black;
                    }
                }
            }
            .dialog_lang{
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -350%;
                margin-top: 85%;
                width: 666px;
                height: 360px;
                border-radius: 10px;
                .el-dialog__headerbtn{
                    width: 50px;
                    position: absolute;
                    top: 8px;
                    right: 0px;
                }
                .header{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    .header_inner{
                        width: 90%;
                        height: 50px;
                        font-family: Poppins, Arial, sans-serif;
                        font-size: 20px;
                        font-weight: 700;
                        color: #000;
                        border: none;
                        display: flex;
                        align-items: center;
                    }
                }
                .body{
                    margin-top: 20px;
                    width: 100%;
                    height: 140px;
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    .nationality,.language{
                        width: 35%;
                        display: flex;
                        flex-direction: column;
                        line-height: 40px;
                        .el-input--medium .el-input__inner{
                            height: 45px;
                        }
                        span{
                            font-size: 14px;
                            font-family: Poppins, Arial, sans-serif;
                            color: #000;
                        }
                        .right-menu-item {
                            margin-left: -9%;
                        }
                    }
                }
            }
        }
    }

    .form_group{
        width: 120px;
        margin-left: 30px;

        .el-select{
            width: 110px;
        }
        .el-input .el-input--medium .el-input--suffix{
            height: 50px;
        }
        .el-input__inner{
            height: 40px;
            border-radius: 10px;
            font-size: 14px;
        }
        .el-select .el-input.is-focus .el-input__inner{
            border-color: rgb(180, 180, 180);
        }
        .el-select .el-input__inner:focus{
            border-color: rgb(180, 180, 180);
        }
    }
}
</style>